import React, { PureComponent } from "react";
import { Drawer, Checkbox, Row, Col } from "antd";

import "./configTableColumns.css";

let header = (
  <div className="title">
    <p className="main">Настроить столбцы</p>
    <p className="sub">Каталог ТС</p>
  </div>
);

class ConfigTableColumns extends PureComponent {
  render() {
    let { close, visible, changed, columns } = this.props;
    return (
      <Drawer
        destroyOnClose
        title={header}
        placement="left"
        width="75%"
        onClose={close}
        visible={visible}
        className="vehiclesTableDrawer"
      >
        <div className="fieldsWrapper">
          <Row>
            <Col span={9}>
              <div className="item">
                <Checkbox
                  checked={columns.productionYear}
                  name="productionYear"
                  onChange={changed}
                >
                  Год выпуска
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.registerSignAndRegion}
                  name="registerSignAndRegion"
                  onChange={changed}
                >
                  Регистрационный знак
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.passengerCapacity}
                  name="passengerCapacity"
                  onChange={changed}
                >
                  Количество мест
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.archiveData}
                  name="archiveData"
                  onChange={changed}
                >
                  Дата архивирования
                </Checkbox>
              </div>
            </Col>
            <Col span={12}>
              <div className="item">
                <Checkbox
                  checked={columns.executors}
                  name="executors"
                  onChange={changed}
                >
                  Исполнители
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.colorName}
                  name="colorName"
                  onChange={changed}
                >
                  Цвет ТС
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.diagnosticCard}
                  name="diagnosticCard"
                  onChange={changed}
                >
                  Срок окончания действия диагностической карты
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  checked={columns.osgoppValidUntil}
                  name="osgoppValidUntil"
                  onChange={changed}
                >
                  Срок окончания действия ОСГОПП страхования
                </Checkbox>
              </div>
              <div className="item">
                <Checkbox
                  name="kaskoValidUntil"
                  checked={columns.kaskoValidUntil}
                  onChange={changed}
                >
                  Срок окончания действия полиса КАСКО
                </Checkbox>
              </div>
            </Col>
          </Row>
        </div>
      </Drawer>
    );
  }
}

export default ConfigTableColumns;
